import { ThemeProvider } from '@emotion/react';
import FormControl from '@mui/material/FormControl';
import { createTheme } from '@mui/material/styles';
import TextField from '@mui/material/TextField';
import { makeStyles, withStyles } from '@mui/styles';
import React from 'react';

const useStyles = makeStyles(theme => ({
  inputText: {
    margin: 'unset',
  },
}));
const colortheme = createTheme({
  palette: {
    error: {
      main: '#c1c1c1',
    },
    primary: {
      main: '#292739',
    },
    secondary: {
      main: '#c1c1c1',
    },
  },
  typography: {
    fontFamily: ['lato'].join(','),
  },
});

const WhiteTextField = withStyles({
  root: {
    margin: '1rem 0rem',
    '& .MuiInputBase-input': {
      color: '#c1c1c1',
    },
    '& .MuiInput-underline:before': {
      borderBottomColor: '#fff8',
      bottom: '-5px',
    },
    '& .MuiInput-underline:hover:before': {
      borderBottomColor: '#fff',
      bottom: '-5px',
    },
    '& .MuiInput-underline:after': {
      borderBottomColor: '#fff',
      bottom: '-5px',
    },
  },
})(TextField);

interface inputTextProps {
  type?: string;
  initValue: string;
  ablefunction?: () => void;
  unablefunction?: () => void;
  setInput: (name: string) => void;
  multiline?: boolean;
}

const InputText: React.FC<inputTextProps> = ({
  initValue,
  setInput,
  multiline,
}) => {
  const classes = useStyles();

  const submitInput = (e: any): void => {
    setInput(e.target.value);
  };

  return (
    <ThemeProvider theme={colortheme}>
      <FormControl
        fullWidth
        sx={{ m: 1 }}
        variant="standard"
        className={classes.inputText}
      >
        <WhiteTextField
          id="input-with-icon-textfield"
          defaultValue={initValue}
          // {type === "user" ? onBlur={CheckUser} : ()}
          //   onBlur={type === "user" ? CheckUser : undefined}
          onBlur={submitInput}
          sx={{ input: { color: '#c1c1c1', margin: 'unset' } }}
          variant="standard"
          multiline={!!multiline}
          rows={4}
        />
      </FormControl>
    </ThemeProvider>
  );
};

export default InputText;
